import { showConfirmModal } from 'src/app/utils/pop_over_maker';
import { RoutingConfig } from 'src/app/utils/routing-config';
import { ToastUtils } from 'src/app/utils/toast_builder';
import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { IonNav, ModalController, PopoverController } from '@ionic/angular';
import { MyPartnersAPI } from '../../../apis/partners.service';
import { Router } from '@angular/router';
import { ModalPartnerComponent } from '../modal-partner/modal-partner.component';
import { PopoverComponent } from 'src/app/widgets/popover/popover.component';
import routes from '../../../config/routing.json';
import { PriorDashboardComponent } from '../../prior-dashboard/prior-dashboard.component';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import Partner from 'src/app/models/partner.model';
import {
  deletePartner,
  loadPartner,
  loadPartnerType,
} from 'src/app/utils/states-management/actions/partner.action';
import { take } from 'rxjs';
import Owner from 'src/app/models/owner.model';
import { ModalActivityComponent } from '../modal-activity/modal-activity.component';
import { deleteActivity, loadActivities } from 'src/app/utils/states-management/actions/activity.action';
import { selectAllActivities } from 'src/app/utils/states-management/selector/activity.selector';
import { ActivityState } from 'src/app/utils/states-management/reducers/activity.reducer';
@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss'],
  providers: [MyPartnersAPI]
})
export class ActivityComponent implements OnInit {
  langage_package;
  title;
  owner_id: number;
  titlemodal: string;
  next;
  return;
  bubble_desc;
  isDashboardView;
  @Input() nav: IonNav;
  @Input() rootStack;
  cropId;
  base_url = environment.appRoot;

  list = [
    {
      id:1,
      key: 'aggregation',
      products: [],
      isOpen: true,
    },
    {
      id:2,
      key: 'washing',
      products: [],
      isOpen: true,
    },
    {
      id:3,
      key: 'sorting',
      products: [],
      isOpen: true,
    },
    {
      id:4,
      key: 'processing',
      products: [],
      isOpen: true,
    },
    {
      id:5,
      key: 'packaging',
      products: [],
      isOpen: true,
    },
  ];

  constructor(
    public modalController: ModalController,
    private router: Router,
    public translateService: TranslateService,
    private toastUtils: ToastUtils,
    private routingConfig: RoutingConfig,
    private popover: PopoverController,
    private store: Store<{ partners: Partner; owner: Owner }>
  ) {

  }

  async presentModal() {
    let modal = await this.toastUtils.modalBuilder(
      ModalActivityComponent,
      {
        activities: this.list,
      },

      ['my-custom-modal-css ', 'modal-wrapper']
    );

  }
  async presentupdateModal(item) {
    let modal = await this.toastUtils.modalBuilder(
      ModalPartnerComponent,
      { item: item },
      ['my-custom-modal-css ', 'modal-wrapper']
    );
  }
  cropLabel = '';
  async getowner_id() {
    this.store
      .select('owner')
      .pipe(take(1))
      .subscribe((value) => (this.owner_id = value.id));
  }
  nextUrl;
  backUrl;
  async ngOnInit() {
    await this.langageChanger();
    [this.nextUrl, this.backUrl] = await Promise.all([
      this.routingConfig.getNextUrl(),
      this.routingConfig.getBackUrl(),
    ]);
    this.store.dispatch(loadActivities());
    this.store.select(selectAllActivities).subscribe((activities) => {
      this.list = (activities || []).map((activity) => ({
        id: activity.id,
        key: activity.key,
        products: activity.farm_post_activities || [],
        isOpen: true,
      }));
    });
    this.translateService.onLangChange.subscribe(async (value) => {
      await this.langageChanger();
    });
    await this.getowner_id();
    // this.get_partners();
    this.isDashboardView = this.router.url.includes(routes.dashboard.home);

  }
  async mnext() {
    this.router.navigateByUrl(await this.routingConfig.getNextUrl());
  }
  async mback() {
    this.router.navigateByUrl(await this.routingConfig.getBackUrl());
  }
  async showPopOver() {
    let componentProps = { key1: this.bubble_desc };

    await this.toastUtils.popOverBuilder(
      componentProps,
      PopoverComponent,
      'popover-custom'
    );
  }
  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if (!this.isDashboardView) {
      // this.showPopOver();
    }
  }
  async langageChanger() {
    this.next = await this.translateService.get('next').toPromise();
    this.return = await this.translateService.get('return').toPromise();

    this.bubble_desc = await this.translateService
      .get('bubble_desc_partner')
      .toPromise();
  }

  onTypeClicked(typeId: string) {
    this.list[typeId]['isOpen'] = !this.list[typeId]['isOpen'];
  }
  async delete(activity_id,id: number) {
    // let modal = await showConfirmModal(
    //   this.popover,
    //   await this.translateService
    //     .get('confirm_delete_buyer')
    //     .toPromise()
    //     .then((value) => value),
    //   null,
    //   await this.translateService.get('confirm').toPromise(),
    //   await this.translateService.get('cancel').toPromise()
    // );

    // const { data } = await modal.onWillDismiss();
    // if (data?.confirmed) {
      this.store.dispatch(deleteActivity({ activity_id: activity_id,id: id }));

    // }
  }

  updateForm(id) {
    this.presentupdateModal(id);
  }


  returnToDashboard() {
    this.nav.setRoot(this.rootStack, {
      nav: this.nav,
      rootStack: PriorDashboardComponent,
    });
  }
}
